export const minutesToTimeString = (totalMinutes: number): string => {
  const hours: number = Math.floor(totalMinutes / 60);
  const minutes: number = totalMinutes % 60;
  const paddedHours: string = hours.toString().padStart(2, "0");
  const paddedMinutes: string = minutes.toString().padStart(2, "0");
  return `${paddedHours}:${paddedMinutes}`;
};

export const timeStringToMinutes = (time: string): number => {
  const [hours, minutes]: number[] = time.split(":").map(Number);
  return hours * 60 + minutes;
};
